export const determineAirlineCode = (
  flightNumber: string | undefined
): string | undefined => {
  if (!flightNumber) return undefined;

  const firstThreeChars = flightNumber.slice(0, 3);
  const containsNumber = /\d/.test(firstThreeChars);
  const airlineCode = containsNumber
    ? firstThreeChars.slice(0, 2)
    : firstThreeChars;

  return airlineCode;
};
